






import { Component, Vue } from 'vue-property-decorator';

function multiBrowserCall(target:any, methodNames:string[]):void {
    for( let name of methodNames ) {
        if( target[name] ) {
            target[name]();
            console.log('multiBrowserCall succeeded with', name);
            return;
        }
    }
    console.log('multiBrowserCall failed for', target, 'with', methodNames);
}

function enterFullscreen():void {
    let elem:HTMLElement = window.document.documentElement;
    multiBrowserCall(elem, [
        'requestFullscreen',
        'webkitRequestFullScreen',
        'mozRequestFullScreen',
        'msRequestFullscreen',
    ]);
}

function exitFullscreen():void {
     let doc:Document = <Document> window.document;
    multiBrowserCall(doc, [
        'exitFullscreen',
        'webkitExitFullscreen',
        'mozCancelFullScreen',
        'msExitFullscreen',
    ]);
}

@Component({
    data() {
        return {isFull: false}
    },
    methods: {
        handleClicked(): void {
            if (this.$data.isFull) {
                exitFullscreen();
                this.$data.isFull = false;
            }
            else {
                enterFullscreen();
                this.$data.isFull = true;
            }
        }
    }
})
export default class FullscreenToggle extends Vue {}
